import React, { FC } from 'react';

import { IssuesCount } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';

import { AccessibilityCriticalIssuesStackedChart } from './AccessibilityCriticalIssuesStackedChart';

interface AccessibilityCriticalIssuesStackedChartContainerProps {
	data?: IssuesCount[];
	isLoading: boolean;
	error: unknown;
}

export const AccessibilityCriticalIssuesStackedChartContainer: FC<
	AccessibilityCriticalIssuesStackedChartContainerProps
> = ({ data, isLoading, error }) => {
	return (
		<AccessibilityCriticalIssuesStackedChart
			data={data}
			isLoading={isLoading}
			error={error ? 'Failed to load critical issues data' : null}
		/>
	);
};
